<div
  rt-overlay-origin
  #timezoneDropdownTrigger="rtOverlayOrigin"
  [class.active]="timezoneDropdown.open"
  [attr.margin-tb-small-x]="hasMargin ? hasMargin : null"
  (click)="toggle(timezoneDropdown)"
  class="timezone"
>
  <div #trigger>
    <ng-content></ng-content>
  </div>
  <div *ngIf="trigger.children.length === 0">
    <p *ngIf="!dropdown && !short && !inputVariant">{{ timeZoneString }}</p>
    <div
      *ngIf="dropdown && !inputVariant && !short"
      [class.dropdownOpened]="timezoneDropdown.open"
      class="only-dropdown"
      layout
      layout-align-items-center
    >
      <p>{{ timeZoneString }}</p>
      <div class="arrow-dropdown"></div>
    </div>
    <rt-button
      *ngIf="short && !inputVariant"
      [class.dropdownOpened]="timezoneDropdown.open"
      variant="plain"
      [dropdownOpened]="timezoneDropdown.open"
    >
      GMT<br />
      {{ timeZoneString }}
    </rt-button>
    <rt-input
      *ngIf="inputVariant"
      [hasDropdownIndicator]="true"
      [value]="timeZoneString"
      [readOnly]="true"
      [class.dropdownOpened]="timezoneDropdown.open"
      variant="rounded"
    >
    </rt-input>
  </div>
</div>
<ng-template
  #timezoneDropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  [origin]="timezoneDropdownTrigger"
  [positions]="positions"
  [minWidth]="dropdownMinWidth"
  (backdropClick)="toggle(timezoneDropdown)"
>
  <rt-time-zone-picker-dropdown
    (close)="toggle(timezoneDropdown)"
    (zoneSelect)="onZoneSelect($event, timezoneDropdown)"
  >
  </rt-time-zone-picker-dropdown>
</ng-template>
